import getFirebaseEnv, {getCurrentTenant, getCurrentEnv} from '../../../configs/dbConfigs' 
import SeedDB from '../../../configs/SeedDB';
import * as firebase from "firebase/app"
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/functions';
import ITrackingEvent from '../../../types/ITrackingEvent';
import IUser, { IUserStatusType } from '../../../types/IUser';
import ITenant from '../../../types/ITenant';
import { toast } from 'react-toastify';
import { debug } from 'console';

const config = getFirebaseEnv();
const TENANT:ITenant = getCurrentTenant();

class FirebaseService {
  readonly tenantId: string;
  auth:any;
  db:any;
  storage:any;
  firestore:any;
  functions:any;

  googleProvider:any;
  facebookProvider:any;
  twitterProvider:any;
  currentUser:IUser = {} as IUser;

  private static firebaseService: FirebaseService;

  private constructor() {
    if(firebase.apps.length === 0){
      firebase.initializeApp(config);
    }
  
    /* Helper */

    //this.serverValue = firebase.database.ServerValue;
    //this.emailAuthProvider = app.auth.EmailAuthProvider;

    /* Firebase APIs */
    this.auth = firebase.auth();
    this.db = firebase.database();
    this.storage = firebase.storage();
    this.firestore = firebase.firestore();
    this.functions = firebase.functions();

    //Emulation
    if(getCurrentEnv() == 'qa'){
      /*this.firestore.settings({
        host: "localhost:8080",
        ssl: false
      });
    */
      //this.firestore.collection('SALESPLAYAPP').doc('tenant_salesplay').set({})
      //debugger
    }
    

    /* Social Sign In Method Provider */

    this.googleProvider = new firebase.auth.GoogleAuthProvider();
    this.facebookProvider = new firebase.auth.FacebookAuthProvider();
    this.twitterProvider = new firebase.auth.TwitterAuthProvider();

    //Initialize the tenant
    this.tenantId = TENANT.tenantId;

    //This will seed any database values the app might need.
    new SeedDB(this).generateFakeCustomerData();

   
  }

  public static getInstance(): FirebaseService {
      if(!FirebaseService.firebaseService){
        this.firebaseService = new FirebaseService()
        return this.firebaseService;
      } else {
        return FirebaseService.firebaseService;
      }
  }

  // *** Auth API ***

  getCurrentUser = ():IUser => {
    return this.currentUser
  };

  doCreateUserWithEmailAndPassword = (email:string, password:string) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email:string, password:string) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSignInWithGoogle = () =>
    this.auth.signInWithPopup(this.googleProvider);

  doSignInWithFacebook = () =>
    this.auth.signInWithPopup(this.facebookProvider);

  doSignInWithTwitter = () =>
    this.auth.signInWithPopup(this.twitterProvider);

  doSignOut = () => this.auth.signOut();

  doPasswordReset = (email:string) => this.auth.sendPasswordResetEmail(email);

  doSendEmailVerification = () =>
    this.auth.currentUser.sendEmailVerification({
      url: process.env.REACT_APP_CONFIRMATION_EMAIL_REDIRECT,
    });

  doPasswordUpdate = (password:string) =>
    this.auth.currentUser.updatePassword(password);

  // *** Merge Auth and DB User API *** //

  onAuthUserListener = (next:any, fallback:any) =>
    this.auth.onAuthStateChanged((authUser:any) => {
      if (authUser && authUser.uid) {
        this.user(authUser.uid)
          .get()
          .then((snapshot:any) => {
            if(snapshot.exists){
              const dbUser = snapshot.data();
              dbUser.uid = snapshot.id;
              // default empty roles
              if (!dbUser.roles) {
                dbUser.roles = {};
                fallback();//donot allow users without roles
              }

              // merge auth and db user
              authUser = {
                uid: authUser.uid,
                email: authUser.email,
                emailVerified: authUser.emailVerified,
                providerData: authUser.providerData,
                ...dbUser,
              };
              next(authUser);
            } else {
              fallback();
            }
          });
      } else {
        fallback();
      }
    });

  tenantDocRef = () => {
    if(this.tenantId)
      return this.firestore.collection('SALESPLAYAPP').doc('tenant_'+this.tenantId);
    else {
      toast.error("Fatal Error. Cannot load tenant");
      throw Error('Cannot determine Tenant');
    }
  }

  // *** exposing database for req queries ***
  database = () => this.db;

  // *** User API ***

  user = (uid:string) => this.tenantDocRef().collection('users').doc(uid);

  users = () => this.tenantDocRef().collection('users');

  // *** Roles API ***

  roles = () => this.tenantDocRef().collection('roles');


  // *** Customer API ***

  customer = (uid:string) => this.tenantDocRef().collection('customers').doc(uid);

  customers = () => this.tenantDocRef().collection('customers');


  // *** Message API ***

/*  message = (uid:string) => this.db.ref(`messages/${uid}`);

  messages = () => this.db.ref('messages');
*/
  // **** Document API ***
  document = (uid:string) => this.tenantDocRef().collection('documents').doc(uid);

  documents = () => this.tenantDocRef().collection('documents');

  // *** Meeting API ***

  meeting = (uid:string, mid:string) => this.db.ref(`users/${uid}/meetings/${mid}`);

  meetings = (uid:string) => this.db.ref(`users/${uid}/meetings`);

  // *** siteSettings API ***/

  settings = () => this.tenantDocRef().collection('settings');

  // **** lookupSettings API ***/

  lookupSettings = () => this.tenantDocRef().collection('lookups');

  lookupSetting = (uid:string) => this.tenantDocRef().collection('lookups').doc(uid);

  //***** Connection Ref Look at App.js for handler */
  connectedRef = () =>  this.db.ref(".info/connected");
  
  // *** Storage Refs ***

  storageRef = () => this.storage.ref('/');

  storageRefFromURL = (url:any) => this.storage.refFromURL(url);

  // **** Template API ********
  template = (uid:string) => this.tenantDocRef().collection('templates').doc(uid);

  templates = () => this.tenantDocRef().collection('templates');

  // ****  Category API ********
  category = (uid: string) => this.tenantDocRef().collection('categories').doc(uid);

  categories = () => this.tenantDocRef().collection('categories');

  // ****  Category API ********
  list = (uid: string) => this.tenantDocRef().collection('lists').doc(uid);

  lists = () => this.tenantDocRef().collection('lists');

  // ****  Configuration API ********
  configuration = (uid: string) => this.tenantDocRef().collection('configurations').doc(uid);

  configurations = () => this.tenantDocRef().collection('configurations');

  // shareable Link  
  sharecodes = () => this.tenantDocRef().collection('sharecodes');

  sharecode = (uid: string) => this.tenantDocRef().collection('sharecodes').doc(uid);

  // Activities
  activities = () => this.tenantDocRef().collection('activities');

  activity = (uid: string) => this.tenantDocRef().collection('activities').doc(uid);

  //Analytics Events
  analytics = () => this.firestore.collection('analytics_0');
  /**
   * IMPORTANT: Slide events are aggregated per document-slide combination.
   * Individual events are meeting specific
   */

  sendTrackingEvent = (event:ITrackingEvent) => {
    this.firestore.collection('tracking_0').add(event);
  }

  /*sendSlideChangeEvent = (meeting:any, userId:string, duration:number):void => {
    const slideNo = meeting.presentation.currentSlide -1;
    const docId = meeting.presentation.docId+"-"+slideNo;
    this.firestore.collection('analytics_0').doc(docId).set(
          {
            eventCategory: 'MEETING',
            event: 'SLIDE_CHANGE',
            title: meeting.title,
            documentId: meeting.presentation.docId,
            slideNo: slideNo,
            totalDuration: firebase.firestore.FieldValue.increment(duration)
          }
    );
    this.firestore.collection('analytics_0').doc(docId).collection('events').add(
      {
        ts: new Date().getTime(),
        meetingId: meeting.uid,
        slideNo: slideNo,
        userId: userId,
        duration: duration
      });
    }*/

  getAgoraToken = (channelName:string, uid:string| number): any => {
    // const method =  this.functions.httpsCallable('generateToken');
    // return method({
    //     channelName: channelName,
    //     uid: uid
    //   });
      //return this.settings().once('value');
  }

  share = async (shareObject: any) => {
    const method =  this.functions.httpsCallable('api/share');
    method({shareObject: shareObject}).then((result:any) => {
      return result.data;
    })
    .catch((error:any) => {
      throw error;
    })
  };

  pushToQueue = async (object: any) => {
    const method =  this.functions.httpsCallable('api/queueService');
    method({object: object}).then((result:any) => {
      return result.data;
    })
    .catch((error:any) => {
      throw error;
    })
  };
}

export default FirebaseService;
